"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _flat = _interopRequireDefault(require("flat"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _cccisdApollo = require("cccisd-apollo");
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _cccisdTable = _interopRequireDefault(require("cccisd-table"));
var _formWrapper = require("../../../reducers/formWrapper.js");
var _style = _interopRequireDefault(require("../style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Fortress = window.cccisd && window.cccisd.fortress;
var TableField = /*#__PURE__*/function (_React$Component) {
  function TableField() {
    var _this;
    _classCallCheck(this, TableField);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TableField, [].concat(args));
    _defineProperty(_this, "state", {
      key: 1,
      loading: true,
      tableData: []
    });
    /* /////////////////////////////////////////////////////////////////////////
    // REACT LIFECYCLE METHODS ////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */
    _defineProperty(_this, "componentDidMount", function () {
      _this.runQuery();
    });
    /* /////////////////////////////////////////////////////////////////////////
    // CLASS METHODS //////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */
    _defineProperty(_this, "getFieldBlockSettings", function () {
      var _this$props = _this.props,
        displaySettings = _this$props.displaySettings,
        field = _this$props.field,
        _this$props$validatio = _this$props.validationSettings,
        validationSettings = _this$props$validatio === void 0 ? {} : _this$props$validatio;
      return {
        field: field,
        label: displaySettings.label || '',
        required: validationSettings.isRequired || false
      };
    });
    _defineProperty(_this, "getMultiSelectProps", function () {
      var value = _this.props.field.value;
      if (_this.props.displaySettings.fieldProps.selectionType === 'multi') {
        var sRows = value && value.length ? value.map(function (e) {
          return e.toString();
        }) : [];
        return {
          rowSelectedCallback: _this.onRowsSelect,
          selectedRows: sRows
        };
      }
      return {};
    });
    _defineProperty(_this, "getSingleSelectProps", function () {
      if (_this.props.displaySettings.fieldProps.selectionType === 'single') {
        return {
          onRowClick: _this.onRowSelect,
          setRowClass: _this.setSingleSelectRowClass
        };
      }
      return {};
    });
    _defineProperty(_this, "getTableProps", function () {
      return _objectSpread(_objectSpread({}, _this.getMultiSelectProps()), _this.getSingleSelectProps());
    });
    /**
     * This method is called when only one row is allowed to be selected.
     * fieldProps.selectionType === 'single'.
     *
     * If fieldProps.allowDeselect is set to true, then no rows selected is
     * allowed (value set to null). E.g., group optionally has a parent group.
     */
    _defineProperty(_this, "onRowSelect", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(row) {
        var _this$props2, fieldProps, field, isUserCheckField, shouldCheckUser, value;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this$props2 = _this.props, fieldProps = _this$props2.displaySettings.fieldProps, field = _this$props2.field, isUserCheckField = _this$props2.isUserCheckField, shouldCheckUser = _this$props2.shouldCheckUser;
              value = (0, _get2["default"])(row, fieldProps.table.props.rowKey);
              if (fieldProps.allowDeselect && (fieldProps.setValueNotArray && value === field.value || !fieldProps.setValueNotArray && field.value.includes(value))) {
                value = null;
              }
              if (!fieldProps.setValueNotArray) {
                value = value === null ? [] : [value];
              }
              _context.n = 1;
              return _this.props.changeAllFields(value, _this.props);
            case 1:
              _this.setState({
                key: _this.state.key + 1
              });
              if (isUserCheckField && shouldCheckUser) {
                _this.props.runCheckUser();
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "onRowsSelect", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(rows) {
        var intRows, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              intRows = rows.map(function (r) {
                return parseInt(r, 10);
              });
              _t = !(0, _isEqual2["default"])(intRows, _this.props.field.value);
              if (!_t) {
                _context2.n = 1;
                break;
              }
              _context2.n = 1;
              return _this.props.changeAllFields(intRows, _this.props);
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "runQuery", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var _this$props$validatio2;
      var _this$props3, displaySettings, operation, row, requiredVariables, variables, response, savedData, data;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            _this$props3 = _this.props, displaySettings = _this$props3.displaySettings, operation = _this$props3.operation, row = _this$props3.row;
            requiredVariables = (0, _get2["default"])(displaySettings, 'fieldProps.requiredVariables', []);
            variables = {};
            requiredVariables.forEach(function (v) {
              if ((0, _get2["default"])(v, 'from') === 'user') {
                variables[v.variable] = (0, _flat["default"])(Fortress)[v.field];
              } else if (operation === 'edit') {
                variables[v.variable] = (0, _get2["default"])(row, v.field);
              }
            });
            _context3.n = 1;
            return _cccisdApollo.client.query({
              query: (0, _cccisdApollo.gql)(displaySettings.fieldProps.query),
              fetchPolicy: 'network-only',
              variables: variables
            });
          case 1:
            response = _context3.v;
            savedData = [];
            data = (0, _get2["default"])(response.data, displaySettings.fieldProps.dataPath);
            data.forEach(function (d) {
              var flatObj = (0, _flat["default"])(d);
              savedData.push(flatObj);
            });
            _this.setState({
              tableData: savedData,
              loading: false
            });
            if (operation !== 'edit' && (_this$props$validatio2 = _this.props.validationSettings) !== null && _this$props$validatio2 !== void 0 && _this$props$validatio2.isRequired && savedData.length === 1) {
              _this.onRowSelect(savedData[0]);
            }
          case 2:
            return _context3.a(2);
        }
      }, _callee3);
    })));
    _defineProperty(_this, "setSingleSelectRowClass", function (row) {
      var _this$props4 = _this.props,
        fieldProps = _this$props4.displaySettings.fieldProps,
        field = _this$props4.field;
      var rowKey = fieldProps.table.props.rowKey;
      if (!fieldProps.setValueNotArray && !(0, _isEmpty2["default"])(field.value) && field.value[0] === row[rowKey]) {
        return 'table-info';
      }
      if (fieldProps.setValueNotArray && field.value === row[rowKey]) {
        return 'table-info';
      }
    });
    return _this;
  }
  _inherits(TableField, _React$Component);
  return _createClass(TableField, [{
    key: "render",
    value:
    /* /////////////////////////////////////////////////////////////////////////
    // RENDER /////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */

    function render() {
      var displaySettings = this.props.displaySettings;
      var columns = (0, _cloneDeep2["default"])(displaySettings.fieldProps.table.columns);
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: this.state.key
      }, this.state.loading && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].loading
      }, /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: true,
        type: "inline"
      })), !this.state.loading && /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, this.getFieldBlockSettings(), /*#__PURE__*/_react["default"].createElement(_cccisdTable["default"], _extends({
        data: this.state.tableData,
        columns: columns
      }, this.getTableProps(), displaySettings.fieldProps.table.props))));
    }
  }]);
}(_react["default"].Component);
_defineProperty(TableField, "propTypes", {
  /**
   * Callback to change the redux value of the field AND
   * all fields that depend on it
   */
  changeAllFields: _propTypes["default"].func,
  displaySettings: _propTypes["default"].object,
  /** The redux form fields object */
  field: _propTypes["default"].object.isRequired,
  /** Each appdef field, keyed by handle (needed for changeAllFields) */
  fieldTypes: _propTypes["default"].object,
  isUserCheckField: _propTypes["default"].bool,
  /** 'create' or 'edit' */
  operation: _propTypes["default"].string,
  /**
   * Array of field handles which should be set to the same value as this
   * field, keyed by handles (needed for changeAllFields)
   */
  requiredByFields: _propTypes["default"].object,
  row: _propTypes["default"].object,
  runCheckUser: _propTypes["default"].func,
  shouldCheckUser: _propTypes["default"].bool,
  validationSettings: _propTypes["default"].object
});
var _default = exports["default"] = (0, _reactRedux.connect)(null, {
  changeAllFields: _formWrapper.changeAllFields
})(TableField);